import createModel, { prop } from './lib/create_model';

export default createModel({
  modelName: 'AbandonedCall',

  properties: {
    customerNumber: prop(String).isRequired,
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/abandoned_call.js